export default {
  permissions(state) {
    return state.permissions || {}
  },
}
